export default __webpack_public_path__ + "static/media/newsPaper.45d07e93.svg";